export default __webpack_public_path__ + "static/media/circulProfile.0a96d9b2.png";